
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiIas as ObiIasElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ias.js';
 
 
 

 
 export const ObiIas = createComponent({
   react: React,
   tagName: 'obi-ias',
   elementClass: ObiIasElement,
   events: {
     
   }
  });
 
 